export const headerConfig = [{
    name: 'title',
    value: 'mission.title',
    width: 246,
}, {
    name: 'status',
    value: 'mission.status',
    width: 105,
}, {
    name: 'valid_from',
    value: 'mission.valid_from',
    width: 363,
}, {
    name: 'valid_to',
    value: 'mission.valid_to',
    width: 363,
}, {
    name: 'publish_time',
    value: 'mission.publish_time',
    width: 363,
}];

